import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import styles from '../styles'
import CheckMark from '../../../../Assets/Images/icons/checkMark'
import classnames from 'classnames'

const ChatMessageView = ({
  isOwnMessage,
  text,
  author,
  time,
  status,
  classes,
  children,
  profilePicture,
}) => {
  return (
    <div
      className={classnames(classes.mainWrapper, {
        'myMessageWrapper': isOwnMessage,
      })}
    >
      <div
        className={classnames(classes.photo, {
          'myPhoto': isOwnMessage,
          'userPhoto': !isOwnMessage,
        })}
      >
        <img src={profilePicture} alt="" />
      </div>

      <article
        className={classnames(classes.wrapper, {
          'curveRight': isOwnMessage,
          'ownMessageWrapper': isOwnMessage,
          'curveLeft': !isOwnMessage,
          'userMessageWrapper': !isOwnMessage,
        })}
      >
        <div className={classes.authorMessageWrapper}>
          <span className={classes.author}>{author}</span>
          {children}
        </div>
        <div className={classes.footerStyles}>
          <span className={classes.time}>{time}</span>
          {isOwnMessage && (
            <div className={classes.status}>
              {status === 'READ' && <CheckMark className={classes.readMark} />}
              <CheckMark className={classes.sentMark} />
            </div>
          )}
        </div>
      </article>
    </div>
  )
}

ChatMessageView.propTypes = {
  isOwnMessage: PropTypes.bool,
  text: PropTypes.string,
  author: PropTypes.string,
  time: PropTypes.string,
  status: PropTypes.string,
  classes: PropTypes.object,
}

export default injectStyles(styles)(ChatMessageView)



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatMessage/component/ChatMessageView.js